import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-station-page page section py-5" }
const _hoisted_2 = { class: "columns h-100" }
const _hoisted_3 = { class: "column is-6 center" }
const _hoisted_4 = { class: "lets-get-started" }
const _hoisted_5 = { class: "add-station-title" }
const _hoisted_6 = { class: "add-station-subtitle" }
const _hoisted_7 = { class: "column is-6 center" }
const _hoisted_8 = { class: "has-text-weight-bold has-text-link is-size-4" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('add_station.lets_get_started')), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('add_station.start_by_adding_aura')), 1 /* TEXT */),
          _createVNode(_component_n_form, {
            ref: "AddStationForm",
            model: _ctx.result,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.result) = $event)),
            rules: _ctx.rules,
            class: "add-station-input",
            inline: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_form_item, {
                label: _ctx.$t('add_station.enter_pairing_token'),
                path: "pairingToken",
                style: {"width":"60%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_input, {
                    round: "",
                    value: _ctx.result.pairingToken,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.result.pairingToken) = $event)),
                    placeholder: _ctx.$t('add_station.enter_pairing_token'),
                    size: "large"
                  }, null, 8 /* PROPS */, ["value", "placeholder"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["label"]),
              _createVNode(_component_n_form_item, { style: {"width":"40%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    onClick: _ctx.submit,
                    disabled: !_ctx.valid || _ctx.pristine,
                    round: "",
                    class: "ml-2",
                    size: "large",
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('add_station.add_station')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick", "disabled"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model", "rules"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('add_station.welcome_to_dashboard')), 1 /* TEXT */),
        _createElementVNode("img", {
          src: require('@/add-station.png').default
        }, null, 8 /* PROPS */, _hoisted_9)
      ])
    ])
  ]))
}